import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import {
  actionGetUsers,
  actionDeleteUser,
  actionSaveUser,
  actionTransferPoints,
  actionSendNotification,
  actionAddTagsToUsers,
} from "../actions/UserActions";
import {
  actionSaveTag,
  actionGetTags,
  actionDeleteTagFromUser,
} from "../actions/TagActions";
import {
  actionGetRoles,
  actionGetRolesRedimidores,
} from "../actions/RolActions";
import { LOGIN_ROUTE, USERS_EDIT_ROUTE } from "../config/RoutesConstants";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  FormControl,
  Input,
  FormHelperText,
  DialogTitle,
  Fab,
  FormControlLabel,
  IconButton,
  InputBase,
  ListItemText,
  ListItem,
  ListItemIcon,
  MenuItem,
  Paper,
  Select,
  Grid,
  SvgIcon,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  InputLabel,
  TablePagination,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import ColorField from "../components/ColorField/ColorField";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Backspace";
import BlockIcon from "@material-ui/icons/Block";
import ActiveIcon from "@material-ui/icons/CheckCircle";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import NotificationIcon from "@material-ui/icons/Notifications";
import StarRateRounded from "@material-ui/icons/StarRateRounded";
import RefreshIcon from "@material-ui/icons/Sync";
import TagIcon from "@material-ui/icons/Brightness1";
import AddTagIcon from "@material-ui/icons/Bookmark";
import Util, { SUCCESS, ERROR } from "../common/Util";
import AssignRolToUser from "./users/AssignRolToUser";
import NotifyUser from "./users/NotifyUser";
import VerifiedIcon from "@material-ui/icons/VerifiedUser";
// import NoVerifiedIcon from '@material-ui/icons/FaceRetouchingOffIcon';
import Settings from "../provider/base/Settings";
import moment from "moment";

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
const filterTag = createFilterOptions();
class Users extends React.PureComponent {
  constructor(props) {
    super(props);
    // let tags = []
    // tags.push({tagName:"Flores", tagColor:"#34FFc6"})
    // tags.push({tagName:"Manzanas", tagColor:"#FF3333"})
    // tags.push({tagName:"Cielos", tagColor:"#3333EE"})
    // tags.push({tagName:"Naranjas", tagColor:"#7722FF"})

    this.state = {
      page: 0,
      rowPerPage: 5,
      count: 0,
      users: [],
      isTagVisible: true,
      loyalyPopUp: null,
      loyalyUserSelected: null,
      filter: "",
      userForDelete: false,
      assignRol: false,
      userSelected: null,
      orderBy: "init_date",
      orderDesc: true,
      birthmonth: -1,
      birthdateFrom: "",
      birthdateTo: "",
      userForVerify: false,
      userVerifyTitle: "",
      userVerifyContentText: "",
      userVerifyToolTipOk: "",
      userVerifyBtnLabel: "",
      qntity: "",
      tags: props.tagList,
      tagText: "",
      tagsSelected: [],
      addTagColor: "#000000",
      tagsSelected: [],
      usersSelected: [],
      tagForDelete: null,
      tagsFilterSelected: [],
      rolesFilterSelected: [],
      onlyDeleted:false,
      allUsersSelected:false
    };
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.getDeleteUserSuccess = this.getDeleteUserSuccess.bind(this);
    this.onConfirmDeleteUser = this.onConfirmDeleteUser.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSortByField = this.onSortByField.bind(this);
    this.sortUsers = this.sortUsers.bind(this);
    this.onChangeDniTransfer = this.onChangeDniTransfer.bind(this);
    this.transferPoints = this.transferPoints.bind(this);
    this.onCloseEditUser = this.onCloseEditUser.bind(this);
    this.onNotifyUser = this.onNotifyUser.bind(this);
    this.sendNotificationToVerifiedUser = this.sendNotificationToVerifiedUser.bind(
      this
    );
    this.toMoment = this.toMoment.bind(this);
    this.onChangeFrom = this.onChangeFrom.bind(this);
    this.onChangeTo = this.onChangeTo.bind(this);
    this.onFilterDate = this.onFilterDate.bind(this);
    this.onChangeMonth = this.onChangeMonth.bind(this);
    this.onClearBirthdateFilter = this.onClearBirthdateFilter.bind(this);
    this.onConfirmVerifyUser = this.onConfirmVerifyUser.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.onSelectTag = this.onSelectTag.bind(this);
    this.onSelectFilterTag = this.onSelectFilterTag.bind(this);
    this.onSelectFilterRol = this.onSelectFilterRol.bind(this);
    this.onSaveTag = this.onSaveTag.bind(this);
    this.onSelectAllUser = this.onSelectAllUser.bind(this);
    this.onAddTag = this.onAddTag.bind(this);
    this.onConfirmDeleteTagFromUser = this.onConfirmDeleteTagFromUser.bind(
      this
    );
    this.onChangeOnlyDeleted = this.onChangeOnlyDeleted.bind(this)
  }

  componentWillMount() {
    if (this.props.login) {
      this.onChangePage()
      this.props.actionGetRoles(null, (e) => {
        console.log("ERROR AL LISTAR ROLES", e);
      });
      this.props.actionGetRolesRedimidores(null, (e) => {
        console.log("ERROR AL LISTAR ROLES REDIMIDORES", e);
      });
      this.props.actionGetTags(
        () => {
          this.setState({ tags: this.props.tagList });
        },
        (e) => {
          console.log("ERROR AL LISTAR TAGS", e);
        }
      );
    }else{
      this.props.history.replace(LOGIN_ROUTE);
    }
  }

  getUsersError(e) {
    console.log("ERROR GET USERS", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los usuarios.");
  }

  onRefresh() {
    this.onChangePage(null, this.state.page);
  }

  onSearch(evt) {
    this.setState({ filter: evt.target.value }, this.onChangePage);
  }

  onChangeMonth(event) {
    this.setState({ birthmonth: event.target.value });
  }

  onChangeFrom(event) {
    if (
      !event.target.value ||
      (parseInt(event.target.value) <= 31 && parseInt(event.target.value) >= 1)
    ) {
      this.setState({ birthdateFrom: event.target.value });
    }
  }

  onChangeTo(event) {
    if (
      !event.target.value ||
      (parseInt(event.target.value) <= 31 && parseInt(event.target.value) >= 1)
    ) {
      this.setState({ birthdateTo: event.target.value });
    }
  }

  onFilterDate() {
    const { birthmonth, birthdateFrom, birthdateTo } = this.state;
    let validSearch = true;
    if (birthmonth == -1) {
      validSearch = false;
      Util.showNoty(
        ERROR,
        "Debe seleccionar el mes para filtrar por cumpleaños"
      );
    }
    if (!birthdateFrom) {
      validSearch = false;
      Util.showNoty(
        ERROR,
        "Debe seleccionar un día desde para filtrar por cumpleaños"
      );
    }
    if (!birthdateTo) {
      validSearch = false;
      Util.showNoty(
        ERROR,
        "Debe seleccionar un día hasta para filtrar por cumpleaños"
      );
    }
    if (
      birthdateFrom &&
      birthdateTo &&
      parseInt(birthdateTo) < parseInt(birthdateFrom)
    ) {
      validSearch = false;
      Util.showNoty(
        ERROR,
        "Debe seleccionar un día hasta posterior o igual al día desde para filtrar por cumpleaños"
      );
    }
    if (validSearch) {
      this.onChangePage();
    }
  }

  onClearBirthdateFilter() {
    this.setState(
      { birthdateFrom: "", birthdateTo: "", birthmonth: -1 },
      this.onChangePage
    );
  }

  onSortByField(field) {
    if (field == this.state.orderBy) {
      this.setState({ orderDesc: !this.state.orderDesc }, this.onChangePage);
    } else {
      this.setState({ orderBy: field }, this.onChangePage);
    }
  }

  sortUsers(a, b) {
    try {
      if (
        this.state.orderBy == "proInactiveAccount" ||
        this.state.orderBy == "proVerified"
      ) {
        if (b[this.state.orderBy]) {
          return this.state.orderDesc ? 1 : -1;
        } else {
          return this.state.orderDesc ? -1 : 1;
        }
      }
      if (b[this.state.orderBy] && !a[this.state.orderBy]) {
        return 1;
      }
      if (!b[this.state.orderBy] && a[this.state.orderBy]) {
        return -1;
      }
      if (!b[this.state.orderBy] && !a[this.state.orderBy]) {
        return 0;
      }
      // console.log("SORT", this.state.orderBy, this.state.orderDesc,b[this.state.orderBy] - a[this.state.orderBy])
      if (this.state.orderDesc) {
        if (this.state.orderBy == "proLastName") {
          return `${b[this.state.orderBy]} ${b["proName"]}`.localeCompare(
            `${a[this.state.orderBy]} ${a["proName"]}`
          );
        }
        if (this.state.orderBy == "init_date") {
          // console.log("SORT INIT DATE",
          // this.state.orderDesc,
          // a.proEmail, b.proEmail,
          // moment.unix(a.init_date).toString(),
          // moment.unix(b.init_date).toString(),
          // moment.unix(a.init_date).isBefore(moment.unix(b.init_date),'min')?-1:1)
          return moment.unix(b.init_date).isBefore(moment.unix(a.init_date))
            ? -1
            : 1;
        }
        if (this.state.orderBy == "proVerificationTime") {
          return Util.timestampToMoment(b.proVerificationTime).isBefore(
            Util.timestampToMoment(a.proVerificationTime)
          )
            ? -1
            : 1;
        }
        if (this.state.orderBy == "proDNI") {
          return b[this.state.orderBy] < a[this.state.orderBy] ? -1 : 1;
        }
        if (this.state.orderBy == "proRoles") {
          return b[this.state.orderBy].length < a[this.state.orderBy].length
            ? -1
            : 1;
        }
        return b[this.state.orderBy].localeCompare(a[this.state.orderBy]);
      }
      if (this.state.orderBy == "proLastName") {
        return `${a[this.state.orderBy]} ${a["proName"]}`.localeCompare(
          `${b[this.state.orderBy]} ${b["proName"]}`
        );
      }
      if (this.state.orderBy == "init_date") {
        // console.log("SORT INIT DATE",
        //             this.state.orderDesc,
        //             a.proEmail, b.proEmail,
        //             moment.unix(a.init_date).toString(),
        //             moment.unix(b.init_date).toString(),
        //             moment.unix(a.init_date).isBefore(moment.unix(b.init_date))?-1:1)

        return moment.unix(a.init_date).isBefore(moment.unix(b.init_date))
          ? -1
          : 1;
      }
      if (this.state.orderBy == "proVerificationTime") {
        return Util.timestampToMoment(a.proVerificationTime).isBefore(
          Util.timestampToMoment(b.proVerificationTime)
        )
          ? -1
          : 1;
      }
      if (this.state.orderBy == "proDNI") {
        return a[this.state.orderBy] < b[this.state.orderBy] ? -1 : 1;
      }
      if (this.state.orderBy == "proRoles") {
        return a[this.state.orderBy].length < b[this.state.orderBy].length
          ? -1
          : 1;
      }

      return a[this.state.orderBy].localeCompare(b[this.state.orderBy]);
    } catch (e) {
      console.log("SORT ERROR", e);
      return -1;
    }
  }

  onChangeOnlyDeleted(evt){
    this.setState({onlyDeleted:evt.target.checked}, this.onChangePage)
  }

  onChangePage(dta, newPage = 0) {
    let birthdate = null
    if (
      this.state.birthdateFrom &&
      this.state.birthdateTo &&
      this.state.birthmonth != -1
    ) {
      birthdate = {from:moment(),to:moment()}
      birthdate.from.date(this.state.birthdateFrom)
      birthdate.from.month(this.state.birthmonth)
      birthdate.to.date(this.state.birthdateTo)
      birthdate.to.month(this.state.birthmonth)
    }
    let tags = null
    if(this.state.tagsFilterSelected && this.state.tagsFilterSelected.length>0){
      tags = this.state.tagsFilterSelected.map(t=>t.id)
    }
    let roles = null
    if(this.state.rolesFilterSelected && this.state.rolesFilterSelected.length>0){
      roles = this.state.rolesFilterSelected.map(t=>t.id)
    }
    this.props.actionGetUsers(
      { search: this.state.filter, birthdate:birthdate, tags:tags, roles:roles, onlyDeleted:this.state.onlyDeleted },
      { field: this.state.orderBy, desc: this.state.orderDesc },
      { from: newPage*this.state.rowPerPage, size: this.state.rowPerPage },
      () => {
        this.setState({
          page: newPage,
        });
      },
      this.getUsersError
    );
  }

  onChangeRowsPerPage(evt) {
    this.setState(
      {
        rowPerPage: evt.target.value,
      },
      this.onChangePage
    );
  }


  onNotifyUser(user) {
    this.setState({ notifyUser: true, userSelected: user });
  }

  onBlock(user) {
    if (user.proInactiveAccount) {
      user.proInactiveAccount = false;
      this.props.actionSaveUser(
        user,
        () => {
          Util.showNoty(SUCCESS, "Usuario activo");
          this.onChangePage(null, this.state.page);
        },
        (e) => {
          if (!(e && e.status && e.status == 401))
            Util.showNoty(ERROR, "No pudimos activar el usuario");
        }
      );
    } else {
      user.proInactiveAccount = true;
      this.props.actionSaveUser(
        user,
        () => {
          Util.showNoty(SUCCESS, "Usuario inactivo");
          this.onChangePage(null, this.state.page);
        },
        (e) => {
          if (!(e && e.status && e.status == 401))
            Util.showNoty(ERROR, "No pudimos desactivar el usuario");
        }
      );
    }
  }

  sendNotificationToVerifiedUser(user) {
    this.props.actionSendNotification(
      user,
      {
        title: "Verificación de cuenta",
        body:
          "Tu cuenta ya se encuentra verificada, ya podes comprar tickets y disfrutar de los beneficios. Gracias por ser parte.",
      },
      () => {
        Util.showNoty(SUCCESS, "La notificación ha sido enviada.");
      },
      (e) => {
        if (!(e && e.status && e.status == 401)) {
          Util.showNoty(ERROR, "No se pudo enviar la notificación.");
        }
        console.log(
          "ERROR AL ENVIAR NOTIFICACION DE VERIFICACIÓN A UN USUARIO",
          e
        );
      }
    );
  }

  onEditUser(user) {
    //this.props.history.push(USERS_EDIT_ROUTE, user)
    this.setState({ assignRol: true, userSelected: user });
  }
  rechargeLoyalyPoints(user) {
    //this.props.history.push(USERS_EDIT_ROUTE, user)
    this.setState({ loyalyPopUp: true, loyalyUserSelected: user });
  }

  onCloseEditUser(save) {
    if (save == SUCCESS) {
        this.onChangePage(null, this.state.page);
    }
    this.setState({ assignRol: false });
  }

  onDeleteUser(user) {
    this.setState({ userForDelete: user });
  }

  onConfirmDeleteUser() {
    this.props.actionDeleteUser(
      this.state.userForDelete,
      this.getDeleteUserSuccess,
      this.getDeleteUserError
    );
    this.setState({ userForDelete: false });
  }

  getDeleteUserSuccess() {
    this.onChangePage(null, this.state.page);
    Util.showNoty(SUCCESS, "El usuario se eliminó correctamente.");

  }

  getDeleteUserError(e) {
    console.log("ERROR getDeleteUserError", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el usuario.");
  }

  onVerify(user) {
    this.setState({
      userForVerify: user,
      userVerifyTitle: user.proVerified
        ? "Anular Verficación de Usuario"
        : "Verificar Usuario",
      userVerifyContentText: `¿Está seguro que desea ${
        user.proVerified ? "anular la verificación " : "verificar"
      } a ${user.proName} ${user.proLastName}?`,
      userVerifyToolTipOk: user.proVerified
        ? "Anular Verificación"
        : "Verificar usuario",
      userVerifyBtnLabel: user.proVerified ? "Anular" : "Verificar",
    });
  }

  onConfirmVerifyUser() {
    let user = this.state.userForVerify;
    this.setState({ userForVerify: false });
    if (user.proVerified) {
      user.proVerified = false;
      this.props.actionSaveUser(
        user,
        () => {
          Util.showNoty(SUCCESS, "Verificación anulada");
          this.onChangePage(null, this.state.page);
        },
        (e) => {
          if (!(e && e.status && e.status == 401))
            Util.showNoty(
              ERROR,
              "No pudimos anular la verificación del usuario"
            );
        }
      );
    } else {
      user.proVerified = true;
      user.setVerificationTime = true;
      user.proVerificatorUser = this.props.authEmail;
      this.props.actionSaveUser(
        user,
        () => {
          Util.showNoty(SUCCESS, "Usuario verificado");
          this.sendNotificationToVerifiedUser(user);
          this.onChangePage(null, this.state.page);
        },
        (e) => {
          if (!(e && e.status && e.status == 401))
            Util.showNoty(ERROR, "No pudimos verificar el usuario");
        }
      );
    }
  }

  toMoment(d) {
    console.log("TO MOMENT", d, typeof d)
    if (process.env.REACT_APP_HAS_BIRTHDATE_MIGRATED) {
      if (d) {
        if (d._seconds) {
          return moment.unix(d._seconds);
        } else {
          return moment(d);
        }
      }
    } else {
      let m = moment(d, "DD/MM/YYYY");
      if (m.isValid()) {
        return m;
      } else {
        m = moment(d, "DD [de] MMMM YYYY");
        if (m.isValid()) {
          return m;
        } else {
          m = moment(d);
          if (m.isValid()) {
            return m;
          } else {
            return d;
          }        
        }
      }
    }
  }

  onSelectTag(evt, tag) {
    let newTagIdx = tag.findIndex((t) => t.inputValue);
    if (newTagIdx != -1) {
      this.setState({ openAddTag: tag[newTagIdx].inputValue });
      // tag.splice(newTagIdx,1)
    } else {
      let tags = tag.slice();
      this.setState({ tagsSelected: tags });
    }
  }

  onSelectFilterTag(evt, tags) {
    this.setState({ tagsFilterSelected: tags });
  }

  onSelectFilterRol(evt, roles) {
    this.setState({ rolesFilterSelected: roles });
  }

  onSaveTag() {
    this.setState({ savingTag: true });
    let newTag = {
      tagName: this.state.openAddTag,
      tagColor: this.state.addTagColor,
      isTagVisible: this.state.isTagVisible,
    };
    this.props.actionSaveTag(
      newTag,
      (savedTag) => {
        let tagsSelected = this.state.tagsSelected.slice();
        let tags = this.state.tags.slice();
        tags.push(savedTag);
        tagsSelected.push(savedTag);
        this.setState({
          tagsSelected: tagsSelected,
          tags: tags,
          openAddTag: null,
          addTagColor: "#000000",
        });
        Util.showNoty(
          SUCCESS,
          `El tag ${savedTag.tagName} se agregó correctamente`
        );
        this.setState({ savingTag: false });
      },
      (e) => {
        console.log("onSaveTag Error", e);
        Util.showNoty(ERROR, `No pudimos agregar el tag ${newTag.tagName}`);
        this.setState({ savingTag: false });
      }
    );
  }

  onSelectUser(newValue, evt) {
    let users = this.state.usersSelected.slice();
    if (this.state.allUsersSelected&&!evt.target.checked
      ||!this.state.allUsersSelected&&evt.target.checked) {
      users.push({
        id: newValue.id,
        proName: newValue.proName,
        proLastName: newValue.proLastName,
        proDNI: newValue.proDNI,
        proEmail: newValue.proEmail,
      });
    } else {
      let idx = users.findIndex((u) => u.id == newValue.id);
      if(idx>=0){
        users.splice(idx, 1);
      }
    }
    this.setState({ usersSelected: users });
  }

  onSelectAllUser(evt) {
    let users = [];
    this.setState({allUsersSelected:evt.target.checked})
    if (!evt.target.checked){
      this.setState({usersSelected:[]})
    }
    // if (evt.target.checked) {
    //   users = this.state.lastFilteredUsers.map((u) => {
    //     return {
    //       id: u.id,
    //       proName: u.proName,
    //       proLastName: u.proLastName,
    //       proDNI: u.proDNI,
    //       proEmail: u.proEmail,
    //     };
    //   });
    // }
    this.setState({ usersSelected: users });
  }

  onAddTag() {
    let tags = this.state.tagsSelected;
    let users = this.state.usersSelected;
    let allUsersSelected = this.state.allUsersSelected
    this.props.actionAddTagsToUsers(
      tags,
      allUsersSelected,
      users,
      () => {
        Util.showNoty(
          SUCCESS,
          "Agregamos los tags a los usuarios correctamente."
        );
        this.setState({ tagsSelected: [], usersSelected: [] });
        this.onChangePage(null, this.state.page);
      },
      (e) => {
        Util.showNoty(ERROR, "No pudimos agregar los tags a los usuarios.");
      }
    );
  }

  onDeleteTagFromUser(tag, user) {
    this.setState({
      tagForDelete: { tag: tag, user: user },
      deleteTagFromAllUsers: false,
    });
  }

  onConfirmDeleteTagFromUser() {
    const { tagForDelete, deleteTagFromAllUsers } = this.state;
    this.props.actionDeleteTagFromUser(
      tagForDelete.tag.id,
      deleteTagFromAllUsers ? "all" : tagForDelete.user.id,
      () => {
        Util.showNoty(
          SUCCESS,
          "El tag se eliminó correctamente a " +
            (deleteTagFromAllUsers
              ? "los usuarios."
              : `${tagForDelete.user.proName} ${tagForDelete.user.proLastName}.`)
        );
        this.onChangePage(null, this.state.page)
      },
      (e) => {
        console.log("ERROR onConfirmDeleteTagFromUser", e);
        Util.showNoty(
          ERROR,
          "No pudimos eliminar el tag a " +
            (deleteTagFromAllUsers
              ? "los usuarios."
              : `${tagForDelete.user.proName} ${tagForDelete.user.proLastName}.`)
        );
      }
    );
    this.setState({ tagForDelete: null });
  }

  renderTableHeader() {
    const { theme } = this.props;
    const headers = [
      { id: "proEmail", label: "Usuario" },
      { id: "proLastName", label: "Apellido y Nombre" },
      { id: "proDNI", label: "DNI" },
      { id: "proBirthDate", label: "Fecha de nacimiento" },
      { id: "proPhone", label: "Télefono" },
      { id: "init_date", label: "Fecha de registro" },
      { id: "proRoles", label: "Rol" },
      { id: "proInactiveAccount", label: "Status" },
    ];
    if (Settings.IS_USER_VERIFIED) {
      headers.splice(7, 0, { id: "proVerified", label: "Cuenta" });
      headers.splice(
        1,
        0,
        { id: "proInstagram", label: "Instagram" },
        { id: "proVerificatorUser", label: "Verificado por" },
        { id: "proVerificationTime", label: "Fecha verificación" }
      );
    }
    headers.unshift({
      id: "selection",
      label: "Seleccionar todo",
      secondLabel: "Deseleccionar todo",
    });
    return (
      <TableRow>
        {headers.map((headCell, i) => {
          if (i == 0) {
            return (
              <TableCell>
                <Tooltip title={headCell.label}>
                  <Checkbox checked={this.state.allUsersSelected} color="primary" onChange={this.onSelectAllUser} />
                </Tooltip>
              </TableCell>
            );
          }
          if (
            headCell.id == "proBirthDate" ||
            headCell.id == "proInactiveAccount"
          ) {
            return <TableCell> {headCell.label}</TableCell>;
          }
          return (
            <TableCell>
              <TableSortLabel
                active={this.state.orderBy === headCell.id}
                direction={
                  this.state.orderBy === headCell.id && this.state.orderDesc
                    ? "desc"
                    : "asc"
                }
                onClick={() => this.onSortByField(headCell.id)}
                hideSortIcon={true}
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          );
        })}
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }
  openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  renderTableBody() {
    const { theme } = this.props;
    let users = this.props.userList.items;
    if (!users || users.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return users.map((item, index) => {
      let isInactive = item.proInactiveAccount;
      let isVerified = item.proVerified;
      let birthdate = this.toMoment(item.proBirthDate);
      const { proTags = [], proRoles = [] } = item;
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <TableCell>
            <Checkbox
              checked={this.state.allUsersSelected&&!this.state.usersSelected.some((u) => u.id == item.id)
                     ||!this.state.allUsersSelected&&this.state.usersSelected.some((u) => u.id == item.id)
              }
              color="primary"
              onChange={this.onSelectUser.bind(this, item)}
            />
          </TableCell>
          <TableCell>
            <Box>
              <Typography>{item.proEmail}</Typography>
              {proTags &&
                proTags.map((t) => (
                  <Chip
                    label={t.tagName}
                    style={{ backgroundColor: t.tagColor }}
                    onDelete={this.onDeleteTagFromUser.bind(this, t, item)}
                  />
                ))}
            </Box>
          </TableCell>
          {Settings.IS_USER_VERIFIED && (
            <TableCell>
              <Button
                style={{
                  backgroundColor: item.proInstagram ? "aquamarine" : null,
                }}
                onClick={() =>
                  this.openInNewTab(
                    `https://instagram.com/${item.proInstagram}`
                  )
                }
              >
                {item.proInstagram}
              </Button>
            </TableCell>
          )}
          {Settings.IS_USER_VERIFIED && (
            <TableCell>{item.proVerificatorUser}</TableCell>
          )}
          {Settings.IS_USER_VERIFIED && (
            <TableCell>
              {Util.formatDateToShow(
                Util.timestampToMoment(item.proVerificationTime)
              )}
            </TableCell>
          )}
          <TableCell>{`${item.proLastName}, ${item.proName}`}</TableCell>
          <TableCell>{item.proDNI}</TableCell>
          <TableCell>
            {(birthdate &&
              ((birthdate.format && birthdate.format("DD/MM/YYYY")) ||
                birthdate)) ||
              "No Disponible"}
          </TableCell>
          <TableCell>
            {" "}
            <Button
              style={{ backgroundColor: item.proPhone ? "aquamarine" : null }}
              onClick={() =>
                this.openInNewTab(
                  `https://api.whatsapp.com/send/?phone=549${item.proPhone}`
                )
              }
            >
              {item.proPhone}
            </Button>
          </TableCell>
          <TableCell>
            {item.init_date
              ? Util.formatDateToShow(moment.unix(item.init_date))
              : "No Disponible"}
          </TableCell>
          <TableCell>
            {proRoles &&
              proRoles.map((r) => {
                return <Chip label={r.id} color="primary" />;
              })}
          </TableCell>
          {Settings.IS_USER_VERIFIED && (
            <TableCell
              style={
                isVerified
                  ? theme.table.activeCell
                  : theme.overrides.MuiTableCell.body
              }
            >
              {isVerified ? "VERIFICADA" : "NO VERIFICADA"}
            </TableCell>
          )}
          <TableCell
            style={
              isInactive
                ? theme.overrides.MuiTableCell.body
                : theme.table.activeCell
            }
          >
            {isInactive ? "INACTIVO" : "ACTIVO"}
          </TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Notificar usuario">
              <IconButton onClick={this.onNotifyUser.bind(this, item)}>
                <NotificationIcon />
              </IconButton>
            </Tooltip>
            {Settings.hasLoyaly === 'active' && (
              <Tooltip title="Cargar puntos">
                <IconButton
                  onClick={this.rechargeLoyalyPoints.bind(this, item)}
                >
                  <StarRateRounded />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Editar usuario">
              <IconButton onClick={this.onEditUser.bind(this, item)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            {Settings.IS_USER_VERIFIED && (
              <Tooltip
                title={isVerified ? "Anular verficación" : "Verificar usuario"}
              >
                <IconButton onClick={this.onVerify.bind(this, item)}>
                  {isVerified ? (
                    <VerifiedIcon style={{ fill: "green" }} />
                  ) : (
                    <VerifiedIcon style={{ fill: "red" }} />
                  )}
                </IconButton>
              </Tooltip>
            )}
            <Tooltip
              title={isInactive ? "Activar usuario" : "Desactivar usuario"}
            >
              <IconButton onClick={this.onBlock.bind(this, item)}>
                {isInactive ? <ActiveIcon /> : <BlockIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar usuario">
              <IconButton onClick={this.onDeleteUser.bind(this, item)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    });
  }

  onDeleteRenderTag(type, tag) {
    let tags = null;
    let idx = -1;
    if (type == "add") {
      tags = this.state.tagsSelected.slice(0);
      idx = tags.findIndex((t) => t.id == tag.id);
      if (idx >= 0) {
        tags.splice(idx, 1);
      }
      this.setState({ tagsSelected: tags });
    }
    if (type == "filter") {
      tags = this.state.tagsFilterSelected.slice();
      idx = tags.findIndex((t) => t.id == tag.id);
      if (idx >= 0) {
        tags.splice(idx, 1);
      }
      this.setState({ tagsFilterSelected: tags });
    }
    console.log("ON DELETE RENDER TAG", type, tag, idx);
  }

  onDeleteRenderRol(type, rol) {
    let roles = null;
    let idx = -1;
    if (type == "filter") {
      roles = this.state.rolesFilterSelected.slice();
      idx = roles.findIndex((r) => r.id == rol.id);
      if (idx >= 0) {
        roles.splice(idx, 1);
      }
      this.setState({ rolesFilterSelected: roles });
    }
  }

  renderTags(type, tags) {
    let t = tags && tags.filter((t) => !t.add);
    return (
      t &&
      t.map((tag) => (
        <Chip
          label={tag.tagName}
          onDelete={this.onDeleteRenderTag.bind(this, type, tag)}
          avatar={
            <Avatar
              style={{ backgroundColor: tag.tagColor, color: "rgb(0,0,0,0.60" }}
            >
              {tag.tagName.substring(0, 1)}
            </Avatar>
          }
        />
      ))
    );
  }

  renderRoles(type, roles) {
    let r = roles && roles.filter((r) => !r.add);
    return (
      r &&
      r.map((rol) => (
        <Chip
          label={rol.id}
          onDelete={this.onDeleteRenderRol.bind(this, type, rol)}
          avatar={
            <Avatar
              style={{ backgroundColor: "black", color: "rgb(255,255,255,0.60" }}
            >
              {rol.id.substring(0, 1)}
            </Avatar>
          }
        />
      ))
    );
  }
  onChangeDniTransfer(evt) {
    this.setState({ qntity: evt.target.value, dniError: "" });
  }
  transferPoints() {
    const { qntity, loyalyUserSelected } = this.state;
    const { proDNI } = loyalyUserSelected;
    console.log("proDNIproDNI", proDNI);
    if (!qntity || isNaN(qntity)) {
      this.setState({ dniError: "Debe ser un numero valido" });
    } else {
      this.props.actionTransferPoints(
        qntity*1,
        proDNI,
        () => {
          Util.showNoty(SUCCESS, "Se transfirieron los puntos correctamente.");
        },
        () => {
          Util.showNoty(ERROR, "Ocurrió un error al transferir los puntos.");
        }
      );
      this.setState({
        loyalyUserSelected: null,
        loyalyPopUp: false,
        qntity: "",
      });
    }
  }
  renderDialogLoyaly() {
    return (
      <Dialog open={this.state.loyalyPopUp}>
        <DialogTitle>Transferir puntos de fidelizacion</DialogTitle>
        <DialogContent>
          <FormControl error={this.state.dniError ? true : false}>
            <Input
              placeholder="Ingresá el monto"
              shrink
              onChange={this.onChangeDniTransfer}
              value={this.state.qntity}
              helperText={this.state.dniError}
            />
            <FormHelperText>{this.state.dniError}</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancelar">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                this.setState({
                  loyalyPopUp: null,
                  qntity: "",
                  loyalyUserSelected: null,
                });
              }}
            >
              Cancelar
            </Button>
          </Tooltip>
          <Tooltip title="Transferir ticket">
            <Button
              variant="contained"
              color="primary"
              onClick={this.transferPoints}
            >
              Transferir
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { theme, userList, rolList } = this.props;
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Usuarios</Typography>
          <Typography variant="subtitle1">Crea usuarios</Typography>
        </Box>
        <Container style={{ ...theme.table.container, maxWidth: "100%" }}>
          <Paper>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box style={{ display: "flex", alignItems: "center" }}>
                <Typography style={theme.paper.title} variant="h2">
                  Listado de usuarios
                </Typography>
                <Fab
                  onClick={this.onRefresh}
                  size="small"
                  style={{ marginLeft: 16, width: 34, height: 34 }}
                  color="secondary"
                >
                  <RefreshIcon style={{ fontSize: 20 }} />
                </Fab>
              </Box>
              <Box
                style={{
                  display: "flex",
                  width: "40%",
                  marginLeft: 10,
                  paddingRight: 10,
                  marginBottom: 16,
                }}
              >
                <Autocomplete
                  options={this.state.tags}
                  value={this.state.tagsSelected}
                  getOptionLabel={(option) => option.tagName}
                  filterOptions={(options, params) => {
                    const filtered = filterTag(options, params);
                    if (params.inputValue !== "") {
                      filtered.unshift({
                        inputValue: params.inputValue,
                        tagName: `Agregar "${params.inputValue}"`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth label="Agregar tags" />
                  )}
                  renderOption={(t) => (
                    <ListItem>
                      <ListItemIcon>
                        <TagIcon style={{ color: t.tagColor }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          t.add
                            ? `Agregar Tag ${this.state.tagText}`
                            : t.tagName
                        }
                      />
                    </ListItem>
                  )}
                  renderTags={this.renderTags.bind(this, "add")}
                  onChange={this.onSelectTag}
                  loadingText="Cargando tags ..."
                  noOptionsText="Sin tags"
                  selectOnFocus
                  multiple
                  freeSolo
                  filterSelectedOptions
                />
                <Tooltip title="Agregar tags a los usuarios seleccionados">
                  <IconButton style={{ marginTop: 17 }} onClick={this.onAddTag}>
                    <AddTagIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Toolbar
              style={{
                ...theme.table.toolbar,
                justifyContent: "space-between",
              }}
            >
              <Box style={{ width: "35%", marginBottom: 36 }}>
                <Typography>Cumpleaños</Typography>
                <Select
                  value={this.state.birthmonth}
                  onChange={this.onChangeMonth}
                >
                  <MenuItem value={-1}>Mes</MenuItem>
                  {MONTHS.map((m, i) => (
                    <MenuItem value={i}>{m}</MenuItem>
                  ))}
                </Select>
                <TextField
                  value={this.state.birthdateFrom}
                  placeholder="Día desde"
                  type="number"
                  onChange={this.onChangeFrom}
                  style={{ width: 90, marginLeft: 10, marginRight: 10 }}
                />
                <TextField
                  value={this.state.birthdateTo}
                  placeholder="Día hasta"
                  type="number"
                  onChange={this.onChangeTo}
                  style={{ width: 90, marginLeft: 10, marginRight: 10 }}
                />
                <IconButton onClick={this.onFilterDate}>
                  <SearchIcon />
                </IconButton>
                <IconButton onClick={this.onClearBirthdateFilter}>
                  <ClearIcon />
                </IconButton>
              </Box>
              <Box
                style={{
                  display: "flex",
                  width: "20%",
                  marginLeft: 10,
                  paddingRight: 10,
                  marginBottom: 36,
                }}
              >
                <Autocomplete
                  options={this.state.tags}
                  value={this.state.tagsFilterSelected}
                  getOptionLabel={(option) => option.tagName}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth label="Filtrar por tags" />
                  )}
                  renderOption={(t) => (
                    <ListItem>
                      <ListItemIcon>
                        <TagIcon style={{ color: t.tagColor }} />
                      </ListItemIcon>
                      <ListItemText primary={t.tagName} />
                    </ListItem>
                  )}
                  renderTags={this.renderTags.bind(this, "filter")}
                  onChange={this.onSelectFilterTag}
                  loadingText="Cargando tags ..."
                  noOptionsText="Sin tags"
                  selectOnFocus
                  multiple
                  filterSelectedOptions
                />
                <Tooltip title="Filtrar los usuarios por tags">
                  <IconButton
                    style={{ marginTop: 17 }}
                    onClick={() => this.onChangePage()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box
                style={{
                  display: "flex",
                  width: "20%",
                  marginLeft: 10,
                  paddingRight: 10,
                  marginBottom: 36,
                }}
              >
                <Autocomplete
                  options={rolList}
                  value={this.state.rolesFilterSelected}
                  getOptionLabel={(option) => option.id}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth label="Filtrar por roles" />
                  )}
                  renderOption={(r) => (
                    <ListItem>
                      <ListItemText primary={r.id} />
                    </ListItem>
                  )}
                  renderTags={this.renderRoles.bind(this, "filter")}
                  onChange={this.onSelectFilterRol}
                  loadingText="Cargando roles ..."
                  noOptionsText="Sin roles"
                  selectOnFocus
                  multiple
                  filterSelectedOptions
                />
                <Tooltip title="Filtrar los usuarios por roles">
                  <IconButton
                    style={{ marginTop: 17 }}
                    onClick={() => this.onChangePage()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box style={{ width: "25%", paddingLeft: 10, paddingRight: 10 }}>
                <TextField
                  placeholder="Buscar"
                  onChange={this.onSearch}
                  helperText="Filtra por usuario, nombre, apellido, dni o teléfono"
                />
              </Box>
              <Box style={{ width: "15%", paddingLeft: 10, paddingRight: 10 }}>
                <FormControlLabel label="Sólo eliminados"
                  control={
                    <Checkbox color="primary" 
                            checked={this.state.onlyDeleted}
                            onChange={this.onChangeOnlyDeleted}
                          />
                  }
                />
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead>{this.renderTableHeader()}</TableHead>
              <TableBody>{this.renderTableBody()}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.props.userList.size}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.userForDelete}>
            <DialogTitle>Eliminar Usuario</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el usuario?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ userForDelete: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar usuario">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmDeleteUser}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.userForVerify}>
            <DialogTitle>{this.state.userVerifyTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {this.state.userVerifyContentText}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ userForVerify: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title={this.state.userVerifyToolTipOk}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmVerifyUser}
                >
                  {this.state.userVerifyBtnLabel}
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.openAddTag ? true : false}>
            <DialogTitle>{`Agregar tag ${this.state.openAddTag}`}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Seleccione un color para el tag {this.state.openAddTag}
              </DialogContentText>
              <ColorField
                input={{
                  value: this.state.addTagColor,
                  onChange: (evt) => {
                    this.setState({ addTagColor: evt.target.value });
                  },
                }}
              />
              <Grid item xs={2}>
                <InputLabel shrink>¿Es visible el tag en la app?</InputLabel>
                <Select
                  value={this.state.isTagVisible}
                  onChange={(evt) => {
                    this.setState({ isTagVisible: evt.target.value });
                  }}
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </Select>
              </Grid>
            </DialogContent>
            {this.state.savingTag ? (
              <CircularProgress style={{ margin: 30, alignSelf: "center" }} />
            ) : (
              <DialogActions>
                <Tooltip title="Cancelar">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      this.setState({ openAddTag: null });
                    }}
                  >
                    Cancelar
                  </Button>
                </Tooltip>
                <Tooltip title={this.state.userVerifyToolTipOk}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSaveTag}
                  >
                    Agregar tag
                  </Button>
                </Tooltip>
              </DialogActions>
            )}
          </Dialog>
          <Dialog open={this.state.tagForDelete}>
            <DialogTitle>Eliminar Tag</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el tag{" "}
                {this.state.deleteTagFromAllUsers
                  ? "de todos los usuarios"
                  : this.state.tagForDelete &&
                    `del usuario ${this.state.tagForDelete.user.proName} ${this.state.tagForDelete.user.proLastName}`}
                ?
              </DialogContentText>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.deleteTagFromAllUsers}
                    onChange={(evt) => {
                      this.setState({
                        deleteTagFromAllUsers: evt.target.checked,
                      });
                    }}
                  />
                }
                label="Eliminar tag de todos los usuarios"
              />
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ tagForDelete: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar tag">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmDeleteTagFromUser}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          {this.renderDialogLoyaly()}
          <AssignRolToUser
            open={this.state.assignRol}
            onClose={this.onCloseEditUser}
            user={this.state.userSelected}
          />
          <NotifyUser
            open={this.state.notifyUser}
            onClose={() => {
              this.setState({ notifyUser: false });
            }}
            user={this.state.userSelected}
          />
        </Container>
      </Box>
    );
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    authEmail: store.auth.email,
    userList: store.usr.userList,
    tagList: store.tag.tagList,
    rolList: store.rol.rolList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetUsers,
      actionGetRoles,
      actionDeleteUser,
      actionSaveUser,
      actionGetRolesRedimidores,
      actionTransferPoints,
      actionSaveTag,
      actionGetTags,
      actionSendNotification,
      actionAddTagsToUsers,
      actionDeleteTagFromUser,
    },
    dispatch
  );
}

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(Users))
);



// WEBPACK FOOTER //
// ./src/screens/Users.js